import React from 'react';
import AppProviders from './app/AppProviders';
import AppBootstrap from './app/AppBootstrap';

function App() {
  return (
    <AppProviders>
      <AppBootstrap />
    </AppProviders>
  );
}

export default App;
